// extracted by mini-css-extract-plugin
var _1 = "ImageUploaderStyles-module__avatar___qldtp";
var _2 = "ImageUploaderStyles-module__button___B7wNA";
var _3 = "ImageUploaderStyles-module__input___hjp2i";
var _4 = "ImageUploaderStyles-module__modalContent___MgscR";
var _5 = "ImageUploaderStyles-module__photo___R2Yun";
var _6 = "ImageUploaderStyles-module__wrapper___NyTKx";
var _7 = "ImageUploaderStyles-module__wrapper-link___cu_0m";
var _8 = "ImageUploaderStyles-module__wrapper-link___cu_0m";
export { _1 as "avatar", _2 as "button", _3 as "input", _4 as "modalContent", _5 as "photo", _6 as "wrapper", _7 as "wrapper-link", _8 as "wrapperLink" }
